import { render, staticRenderFns } from "./forsta-instructions.vue?vue&type=template&id=3c61c8b2&scoped=true"
import script from "./forsta-instructions.vue?vue&type=script&lang=js"
export * from "./forsta-instructions.vue?vue&type=script&lang=js"
import style0 from "./forsta-instructions.vue?vue&type=style&index=0&id=3c61c8b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c61c8b2",
  null
  
)

export default component.exports